<template>
    <div >
      <div class="header">
	      <p>园圈管理</p>
	    </div>

      <div class="issueTop">
        <span class="issuer-label">发布人</span>
        <el-input v-model='issuer'  style="width:300px;margin-right:60px;" suffix-icon="el-icon-search"  placeholder='请输入发布人姓名'></el-input>
        <el-button type="primary" style="height: 35px;line-height: 10px;" @click="issuerSearch(1)">查询</el-button>
        <el-button type="info" style="height: 35px;line-height: 10px;" @click="reset">重置</el-button>
      </div>
      <el-table
      :data="tableData"
      stripe
      border
      :header-cell-style="bg"
      style="width: 100%">
        <el-table-column
          prop="content"
          label="文字内容"
          min-width="200px"
          header-align="center"
          :formatter="subContent"
          >
        </el-table-column>
        <el-table-column
          label="图片内容"
          prop="fileList"
          align="center"
          min-width="160px">
          <template slot-scope="scope">
            <div class="table-imgBox">
              <div :class="tableImg(scope.row.fileList)" v-for='(item,index) in scope.row.fileList' :key='index' @click='imgBig(item.fileName)'>
                <img :src='item.fileName' class="table-img"/>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="userInfo"
          label="发布人"
          align="center">
          <template slot-scope="scope">
          <span>{{scope.row.userInfo.nickname}}</span>
          </template>
      </el-table-column>
      <el-table-column
          label="发布时间"
          prop="createTime"
          align="center"
          width="140"
          >
          <!--<template slot-scope="scope">-->
            <!--<div class="table-time">-->
              <!--<span>{{scope.row.time}}</span>-->
              <!--<span>{{scope.row.date}}</span>-->
            <!--</div>-->
          <!--</template>-->
      </el-table-column>
      <el-table-column
          prop="likeNum"
          label="点赞数"
          align="center">
      </el-table-column>
      <el-table-column
          prop="commentNum"
          label="评论数"
          align="center">
      </el-table-column>
      <el-table-column
          label="操作"
          align="center">
          <template slot-scope="scope">
            <span style="color:red;cursor:pointer" @click='handleDelete(scope.row.id)'>删除</span>
          </template>
      </el-table-column>
    </el-table>

    <div class="pageWrap">
      <el-pagination
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="count"
        @current-change="clickPage"
        >
      </el-pagination>
    </div>
    <imgpreview :img='imgSrc' :display='imgShow' @close='closeImg'></imgpreview>
    </div>
</template>

<script>
import imgpreview from '@/components/imgPreview'
import {getCircleReport,delCircle} from '@/api/parkManage'
import Base64Utils from './Base64';
export default {
  name: "",
  components:{
    imgpreview
  },
  props: [""],
  data() {
    return {
      bg: {
        "background-color": "#fafafa"
      },
      issuer: "",
      issueTable:[],
      currentPage: 1,
      pageSize: 10,
      count: 0,
      imgSrc: '',
      dialogShow: false,
      imgShow: false,
    };
  },
  mounted(){
    //let subContent=Base64Utils.decoder()
    this.issuerSearch(1)
  },
  computed: {
      tableData() {
        let data = this.issueTable;
        for(let i in data){
          let createTime = data[i].createTime;
          let arr = createTime.split('-');
          data[i].createTime = `${arr[0]}-${arr[1]}-${arr[2]} ${arr[3]}:${arr[4]}`
        }
        return data;
      }
  },
  methods: {
    subContent(row,column,cellValue){
      return Base64Utils.decoder(cellValue)
    },
    issuerSearch(page) {
      this.currentPage = page;
      getCircleReport(this.issuer,this.currentPage,this.pageSize).then(res=>{
          console.log(res);
          this.issueTable = res.data.pageList;
          this.count = parseInt(res.data.count);
      }).catch(error=>{

      })
    },
    reset() {
      this.issuer = "";
    },
    tableImg(img){
      let num = img.length;
      switch (num){
        case 1:
          return 'table-imgOne'
          break;
        case 2:
        case 3:
        case 4:
          return 'table-imgTwo'
          break;
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
          return 'table-imgThree'
          break;
        default:
          return 'table-imgThree'
          break;
      }
    },
    clickPage(page){
      this.issuerSearch(page);
    },
    handleDelete(id){
      let that = this;
      that.$confirm('确认删除此条动态圈？','提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',

      }).then(()=>{
        //@todo 向后台删除数据
        delCircle(id).then(res=>{
          that.$message({
            type: 'success',
            message: '删除成功'
          });
          this.issuerSearch(this.currentPage)
        }).catch(error=>{

        })
      }).catch(()=>{
         that.$message({
            type: 'info',
            message: '已取消删除'
          });
      })
    },
    imgBig(src){
      let that = this;
      that.imgSrc = src;
      that.imgShow = !that.imgShow;
    },
    closeImg(val){
      this.imgShow = !this.imgShow;
    }
  }
};
</script>
<style scoped>
.header {
  display: flex;
  justify-content: space-between;
}

.issuer-label {
  margin-right: 12px;
}
.issueTop{
  margin-bottom: 40px;
}
.table-text{
  margin-left: 20px;
}
.table-time{
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.table-imgBox{
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: center;
}
.table-imgOne{
  /* box-sizing: border-box; */
  flex: 0 0 80%;

}
.table-imgTwo{
  /* box-sizing: border-box; */
  flex: 0 0 40%;
  margin-right: 5px;
  margin-bottom: 5px;
}
.table-imgThree{
  /* box-sizing: border-box; */
  flex: 0 0 30%;
  height: 40px;
  margin-left: 5px;
  margin-bottom: 5px;
}
.table-img{
  height: 100px;
  width: 100px;

}
.pageWrap{
  margin-top: 20px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/park/CircleManage.vue